import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import {
  WhereaboutsReminderSetting,
  WhereaboutsReminderSettingHandle,
} from '../../components/WhereaboutsReminderSetting';
import { SectionSaveButton } from './SectionSaveButton';

export function NotificationsPanel() {
  const { t } = useTranslation();
  const reminderSettingRef = useRef<WhereaboutsReminderSettingHandle>(null);

  const onSave = async () => {
    await reminderSettingRef.current?.save();
  };

  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.notifications-tab')}</HeadlineSmall>
      <WhereaboutsReminderSetting ref={reminderSettingRef} deferSave={true} />
      <SectionSaveButton onSave={onSave} />
    </>
  );
}
